import React, { useState } from "react";

const MedicalMinds = () => {
  const leftProfiles = [
    {
      name: "Dr Dhanya Prabhu Ramadas",
      role: "Consultant Family Physician",
      experience: "17+ Years of Experience",
      bio: "Dr. Dhanya Prabhu Ramadas is a compassionate and dedicated board-certified Family Physician with over 17 years of experience.​",
      image: "/images/new-website/doctor/dhanya-prabhu.webp",
    },

    {
      name: "Dr Sangita Sutradhar",
      role: "Senior Family Physician",
      experience: "18+ Years of Experience",
      image: "images/new-website/doctor/dr-sangitha.webp",
    },

       {
      name: "Dr Sunila Venikar",
      role: "Consultant Physician",
      experience: "25+ Years of Experience",
      image: "images/new-website/doctor/dr-sunila-venikar.webp",
    },

    {
      name: "Rekha Prabhu",
      role: "Consultant Nutritionist",
      experience: "22+ Years of Experience",
      image: "images/new-website/about-page/Rekha (1).webp",
    },


  ];

  const rightProfiles = [
    {
      name: "Dr Preeti Surana (PT)",
      role: "Senior Physiotherapist",
      experience: "20+ Years of Experience",
      image: "/images/new-website/doctor/drpreethi.webp",
    },

    {
      name: "Arpitha Mirchandani",
      role: "Senior Psychologist",
      experience: "17+ Years of Experience",
      image: "images/arpitha-mirchandani.webp",
    },

    {
      name: "Roshan Madhusudhan Suvarna",
      role: "Exercise Specialist",
      experience: "9+ Years of Experience",
      image: "images/new-website/doctor/Roshan-bh.webp",
    },

    {
      name: "Suman Krishnaraj",
      role: "Senior Clinical Nutritionist",
      experience: "9+ Years of Experience",
      image: "images/new-website/about-page/suman-krishnaraj.webp",
    },
  ];

  const additionalLeftProfiles = [

    {
      name: "Dr Eragul S",
      role: "Consultant Physician",
      experience: "6+ Years of Experience",
      image: "images/new-website/doctor/dr-eragul.webp",
    },
    {
      name: "Dr Sesha Padmanaban",
      role: "Consultant Physician",
      experience: "5+ Years of Experience",
      image: "images/new-website/doctor/Dr. Padmanabham.webp",
    },
    
    {
      name: "Hemanth B M",
      role: "Fitness Coach / Exercises Specialist",
      experience: "7+ Years of Experience",
      image: "images/new-website/doctor/Hemanth-B-M.webp",
    },
  ];

  const additionalRightProfiles = [

    {
      name: "Sanjay Karanth",
      role: "Yoga Therapist",
      experience: "6+ Years of Experience",
      image: "images/new-website/doctor/Sanjay-Karanth.webp",
    },
    {
      name: "Naga Sushmitha",
      role: "Yoga Therapist",
      experience: "5+ Years of Experience",
      image: "images/new-website/doctor/Naga-sushmitha.webp",
    },

  ];

  const [visibleLeftProfiles, setVisibleLeftProfiles] = useState(leftProfiles);
  const [visibleRightProfiles, setVisibleRightProfiles] = useState(rightProfiles);
  const [isLeftExpanded, setIsLeftExpanded] = useState(false);
  const [isRightExpanded, setIsRightExpanded] = useState(false);
  const [hoveredProfile, setHoveredProfile] = useState(null);

  const handleLoadMoreLeft = () => {
    if (!isLeftExpanded) {
      setVisibleLeftProfiles([...leftProfiles, ...additionalLeftProfiles]);
    } else {
      setVisibleLeftProfiles(leftProfiles);
    }
    setIsLeftExpanded(!isLeftExpanded);
  };

  const handleLoadMoreRight = () => {
    if (!isRightExpanded) {
      setVisibleRightProfiles([...rightProfiles, ...additionalRightProfiles]);
    } else {
      setVisibleRightProfiles(rightProfiles);
    }
    setIsRightExpanded(!isRightExpanded);
  };

  return (
    <section className="medical-minds-section">
      <div className="medical-minds-container">
        {/* Left Column */}
        <div className="profiles-column colum-border">
          {visibleLeftProfiles.map((profile, index) => (
            <div
              className="profile-card"
              key={index}
              onMouseEnter={() => setHoveredProfile(profile)}
              onMouseLeave={() => setHoveredProfile(null)}
            >
              <img src={profile.image} alt={profile.name} />
              <div className="profile-details">
                <h3>{profile.name}</h3>
                <p>{profile.role}</p>
                {profile.experience && <span>{profile.experience}</span>}
              </div>
              {/* {hoveredProfile === profile && (
                <div className="profile-hover-card">
                  <p>{profile.bio}</p>
                </div>
              )} */}
            </div>
          ))}
          <div className="load-more-container mobile-only">
            <button className="load-more-button" onClick={handleLoadMoreLeft}>
              {isLeftExpanded ? "Show Less" : "Load More"}
            </button>
          </div>
        </div>

        {/* Right Column */}
        <div className="profiles-column">
          {visibleRightProfiles.map((profile, index) => (
            <div
              className="profile-card"
              key={index}
              onMouseEnter={() => setHoveredProfile(profile)}
              onMouseLeave={() => setHoveredProfile(null)}
            >
              <img src={profile.image} alt={profile.name} />
              <div className="profile-details">
                <h3>{profile.name}</h3>
                <p>{profile.role}</p>
                {profile.experience && <span>{profile.experience}</span>}
              </div>
              {/* {hoveredProfile === profile && (
                <div className="profile-hover-card">
                  <p>{profile.bio}</p>
                </div>
              )} */}
            </div>
          ))}
          <div className="load-more-container mobile-only">
            <button className="load-more-button" onClick={handleLoadMoreRight}>
              {isRightExpanded ? "Show Less" : "Load More"}
            </button>
          </div>
        </div>
      </div>

      {/* Desktop Load More Button */}
      <div className="load-more-container desktop-only">
        <button className="load-more-button" onClick={() => { handleLoadMoreLeft(); handleLoadMoreRight(); }}>
          {isLeftExpanded && isRightExpanded ? "Show Less" : "Load More"}
        </button>
      </div>
    </section>
  );
};

export default MedicalMinds;
